/*
 * De geurfamilies en noten waarop we labelen, op één plek.
 *
 * Twee schermen tonen dezelfde pillen: de slider "Pairs with your cart" in het
 * winkelmandje en de uitslag van de quiz. Twee kopieën van deze lijsten zouden
 * op een dag uit elkaar lopen, en dan heet hetzelfde parfum in het mandje
 * Oriental en in de quiz Woody.
 */
(function () {
  /*
   * Bewust een vaste lijst en niet "alle tags": een product draagt ook
   * 'bestseller', 'Parfum', leeftijdsgroepen en de naam van het merk waar het
   * op geïnspireerd is. Daarop labelen levert onzin op.
   */
  var FAMILIES = [
    'Chypre', 'Boozy', 'Green', 'Creamy', 'Aquatic', 'Powdery', 'Clean',
    'Gourmand', 'Aromatic', 'Citrus', 'Fruity', 'Spicy', 'Oriental', 'Sweet',
    'Woody', 'Floral', 'Musky', 'Musk', 'Amber',
  ];

  /*
   * De volgorde is niet alfabetisch maar van zeldzaam naar algemeen, want het
   * eerste rake label komt op de kaart. Amber zit op 53 van de 115 geuren en
   * zegt dus weinig; Chypre op een handvol en zegt veel.
   */
  var NOTES = [
    'Vanilla', 'Oud', 'Rose', 'Jasmine', 'Sandalwood', 'Patchouli', 'Bergamot',
    'Leather', 'Tonka Bean', 'Saffron', 'Cedar', 'Iris', 'Lavender', 'Vetiver',
    'Tobacco', 'Coconut', 'Peach', 'Cherry', 'Almond', 'Caramel', 'Honey',
    'Pepper', 'Cardamom', 'Incense', 'Orange Blossom', 'Praline', 'Coffee',
  ];

  function pick(tags, lijst) {
    var lower = (tags || []).map(function (t) { return String(t).toLowerCase(); });
    for (var i = 0; i < lijst.length; i += 1) {
      if (lower.indexOf(lijst[i].toLowerCase()) > -1) return lijst[i];
    }
    return null;
  }

  /*
   * Twee labels per kaart, zoals de scentlabel-velden op de productpagina: de
   * geurfamilie en een noot die eruit springt. We leiden ze af uit de tags in
   * plaats van uit de metafields, want die zitten niet in products.json en ze
   * per product ophalen zou honderdvijftien extra verzoeken kosten.
   */
  function labelsFor(tags) {
    var out = [];
    var familie = pick(tags, FAMILIES);
    var noot = pick(tags, NOTES);
    if (familie) out.push(familie === 'Musk' ? 'Musky' : familie);
    if (noot && noot !== familie) out.push(noot);
    return out;
  }

  window.SentirScentLabels = {
    FAMILIES: FAMILIES,
    NOTES: NOTES,
    pick: pick,
    labelsFor: labelsFor,
  };
})();
